import LocalStorage from '../local-storage/LocalStorage'

const TRANSPORT_KEY = 'printer.transport'
const BLUETOOTH_NAME_KEY = 'printer.bluetoothName'
const USB_DEVICE_KEY = 'printer.usbDeviceKey'
const LABEL_SIZE_KEY = 'printer.labelSize'
const DPI_KEY = 'printer.dpi'
const MODEL_KEY = 'printer.model'

/**
 * The Bluetooth printer is keyed by name rather than MAC address because that is all
 * the Cordova BT plugin exposes — its connect() takes a name and matches it against
 * the bonded list. Two identically named printers cannot be told apart.
 */
const PrinterStorage = {
  getTransport: (): string | undefined => LocalStorage.get<string>(TRANSPORT_KEY),
  setTransport: (transport: string): void => LocalStorage.set(TRANSPORT_KEY, transport),

  getBluetoothName: (): string | undefined => LocalStorage.get<string>(BLUETOOTH_NAME_KEY),
  setBluetoothName: (name: string): void => LocalStorage.set(BLUETOOTH_NAME_KEY, name),
  clearBluetoothName: (): void => LocalStorage.remove(BLUETOOTH_NAME_KEY),

  // "vendor:product" in hex rather than Android's deviceId, which is reassigned on
  // every replug and would invalidate the selection each time the cable moved.
  getUsbDeviceKey: (): string | undefined => LocalStorage.get<string>(USB_DEVICE_KEY),
  setUsbDeviceKey: (deviceKey: string): void => LocalStorage.set(USB_DEVICE_KEY, deviceKey),
  clearUsbDeviceKey: (): void => LocalStorage.remove(USB_DEVICE_KEY),

  // Physical label stock. Seeded from the server's per-vendor default, overridable
  // on the device because the stock in the printer is a local fact.
  getLabelSize: (): string | undefined => LocalStorage.get<string>(LABEL_SIZE_KEY),
  setLabelSize: (size: string): void => LocalStorage.set(LABEL_SIZE_KEY, size),
  clearLabelSize: (): void => LocalStorage.remove(LABEL_SIZE_KEY),

  // Detected from the printer via ZPL ~HI rather than chosen by the seller — dpi is a
  // fixed property of the hardware, and a wrong value silently rescales every label.
  getDpi: (): number | undefined => LocalStorage.get<number>(DPI_KEY),
  setDpi: (dpi: number): void => LocalStorage.set(DPI_KEY, dpi),
  clearDpi: (): void => LocalStorage.remove(DPI_KEY),

  getModel: (): string | undefined => LocalStorage.get<string>(MODEL_KEY),
  setModel: (model: string): void => LocalStorage.set(MODEL_KEY, model),
}

export default PrinterStorage
